import type { GetScheduleAddresses } from '@entities/schedules/address/types.ts';
import { createApi } from '@reduxjs/toolkit/query/react';
import { getRtkConfig } from '@shared/config/index';
import { doConvertDataToFormData } from '@shared/helpers/index';
import type { ScheduleAddress } from '@shared/types/schedules';

const scheduleAddressApi = createApi({
  reducerPath: 'scheduleAddressQueries',
  baseQuery: getRtkConfig('/api/v1/'),
  tagTypes: ['scheduleAddresses'],
  keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
  endpoints: (build) => ({
    getScheduleAddresses: build.query<GetScheduleAddresses, undefined>({
      query: (params) => ({
        url: `schedules/address`,
        params,
      }),
      providesTags: ['scheduleAddresses'],
    }),

    createScheduleAddress: build.mutation<Response, Partial<ScheduleAddress>>({
      // createScheduleAddress: build.mutation<Response, FormData>({
      query: (data) => {
        return {
          url: 'schedules/address/',
          method: 'POST',
          body: doConvertDataToFormData(data),
        };
      },
      invalidatesTags: ['scheduleAddresses'],
    }),

    getScheduleAddress: build.query<ScheduleAddress, { addressId?: string }>({
      query: (params) => ({
        // params,
        url: `schedules/address/${params.addressId}`,
        method: 'GET',
      }),
      providesTags: ['scheduleAddresses'],
    }),

    updateScheduleAddress: build.mutation<Response, Partial<ScheduleAddress>>({
      query: ({ id, ...data }) => ({
        url: `schedules/address/${id}/`,
        method: 'PATCH',
        body: {
          ...data,
        },
      }),
      invalidatesTags: ['scheduleAddresses'],
    }),

    deleteScheduleAddress: build.mutation<Response, { id: string }>({
      query: ({ id }) => ({
        url: `schedules/address/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['scheduleAddresses'],
    }),
  }),
});

export const {
  useGetScheduleAddressesQuery,
  useGetScheduleAddressQuery,
  useCreateScheduleAddressMutation,
  useUpdateScheduleAddressMutation,
  useDeleteScheduleAddressMutation,
} = scheduleAddressApi;

export const scheduleAddressApiReducerPath = scheduleAddressApi.reducerPath;

export const scheduleAddressQueriesReducer = scheduleAddressApi.reducer;

export const scheduleAddressMiddleware = scheduleAddressApi.middleware;
